import { FormControlLabel, styled } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

import { useI18n } from '@app-velocity/i18n';
import { Checkbox, Form } from '@app-velocity/ui';

import { PersonaFormValues } from '../../../../types/persona';

const StyledSection = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

const StyledDeviceList = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
}));

export const InputDevicesSection = () => {
  const { t } = useI18n();
  const { control } = useFormContext<PersonaFormValues>();

  const devices = [
    {
      name: 'inputDevicesMouse' as const,
      label: t('personas:form.input_devices_mouse'),
    },
    {
      name: 'inputDevicesKeyboard' as const,
      label: t('personas:form.input_devices_keyboard'),
    },
    {
      name: 'inputDevicesTouch' as const,
      label: t('personas:form.input_devices_touch'),
    },
  ];

  return (
    <StyledSection>
      <Form.Label>
        <Form.HeadlessLabelWithTooltip
          tooltip={t('personas:form.tooltips.input_devices')}
        >
          {t('personas:form.input_devices')}
        </Form.HeadlessLabelWithTooltip>
      </Form.Label>
      <StyledDeviceList>
        {devices.map(({ name, label }) => (
          <FormControlLabel
            key={name}
            label={label}
            control={
              <Controller
                name={name}
                control={control}
                render={({ field: { onChange, value } }) => (
                  <Checkbox checked={value} onChange={onChange} />
                )}
              />
            }
          />
        ))}
      </StyledDeviceList>
    </StyledSection>
  );
};
